// Phase 4.5: ported from aiia-voice-web/src/lib/config.js.
//
// After the monorepo consolidation, the voice room runs on the same origin
// as the recruiter portal (Next.js). The defaults derive every URL from
// window.location so the same build works on aiia-test, sandbox, and prod
// without recompiling.
//
// Escape hatches remain for anyone who needs to point at a different host:
//   NEXT_PUBLIC_API_URL           override REST base
//   NEXT_PUBLIC_VOICE_WS_URL      override voice WebSocket base
//   NEXT_PUBLIC_DJANGO_WS_URL     override record WebSocket base
//   NEXT_PUBLIC_POST_INTERVIEW_REDIRECT   where candidates go after hang-up

const getBrowserOrigin = (): string => {
  if (typeof window !== "undefined" && window.location) {
    return window.location.origin;
  }
  return "";
};

const toWsOrigin = (httpOrigin: string): string =>
  httpOrigin.replace(/^http/, "ws");

const trimTrailing = (value: string): string => value.replace(/\/+$/, "");

const pick = (envValue: string | undefined, fallback: string): string => {
  if (envValue && envValue.length > 0) return trimTrailing(envValue);
  return trimTrailing(fallback);
};

const browserOrigin = getBrowserOrigin();
const browserWsOrigin = toWsOrigin(browserOrigin);

export const API_URL = pick(
  process.env.NEXT_PUBLIC_API_URL,
  browserOrigin
);

export const VOICE_WS_URL = pick(
  process.env.NEXT_PUBLIC_VOICE_WS_URL,
  browserWsOrigin
);

export const DJANGO_WS_URL = pick(
  process.env.NEXT_PUBLIC_DJANGO_WS_URL,
  browserWsOrigin
);

export const POST_INTERVIEW_REDIRECT = trimTrailing(
  process.env.NEXT_PUBLIC_POST_INTERVIEW_REDIRECT || "/"
);
